import React, { useEffect, useState, useRef } from 'react';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';
import getImageUrl from '@configuratorware/configurator-frontendgui/App/Utils/getImageUrl';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useMediaQuery, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import _ from 'lodash';
import get from 'lodash/get';
import size from 'lodash/size';
import keys from 'lodash/keys';
import Check from '@material-ui/icons/Check';
import { green, black, white, grey, lightergrey } from '../../Constants/Colors';
import { Option, OptionClassification } from '../../types';
import noImage from '../../Resources/Images/no_image.svg';
import MarkdownText from '../MarkdownText/MarkdownText';
import { hidePrices } from '../../Helpers';
import PriceInfoDialog from '../PriceInfoDialog/PriceInfoDialog';

const useStyles = makeStyles(
  (theme) => ({
    optionTilesContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexFlow: 'wrap',
      overflow: 'hidden',
      [theme.breakpoints.between('sm', 'md')]: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '20px',
        justifyContent: 'flex-start',
      },
    },
    imgOptionDetails: {
      padding: '20px 20px 0px',
      width: '100%',
    },
    optionTile: {
      width: 'calc(25% - 40px)',
      maxWidth: 'min(452px, 100%)',
      minWidth: 'min(360px, 100%)',
      margin: '0px 40px 40px 0',
      border: '2px solid ' + grey,
      backgroundColor: white,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      [theme.breakpoints.between('sm', 'md')]: {
        width: 'calc(25% - 15px)',
        margin: 0,
        minWidth: 'unset',
        maxWidth: 'unset',
        flex: '0 0 calc(25% - 15px)',
      },
      [theme.breakpoints.down('sm')]: {
        margin: '0px 0px 10px 0',
      },
    },
    selectedOption: {
      borderColor: green,
    },
    priceContainer: {
      padding: '20px 0px',
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      [theme.breakpoints.between('sm', 'md')]: {
        padding: '10px 0px',
        flexDirection: 'column',
      },
    },
    optionPrice: {
      '& p': {
        fontSize: 17,
        fontFamily: 'Inter',
        [theme.breakpoints.between('sm', 'md')]: {
          fontSize: 10,
        },
      },
    },
    deliveryTime: {
      paddingTop: '3px',
      '& p': {
        color: green,
        [theme.breakpoints.between('sm', 'md')]: {
          fontSize: 10,
        },
      },
    },
    selectBtn: {
      width: '100%',
      fontSize: 14,
      fontFamily: 'Inter',
      fontWeight: 700,
      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: 12,
        marginTop: '10px',
      },
    },
    selectedOptionBtn: {},
    optionImage: {
      width: 448,
      maxHeight: 268,
      maxWidth: '100%',
      '&.imageNotAvailableElement': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      },
      '& img': {
        height: 60,
        width: 60,
      },
    },
    optionDetails: {
      padding: '20px 20px 40px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flexGrow: 1,
      [theme.breakpoints.between('sm', 'md')]: {
        padding: '15px',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '15px',
      },
    },
    optionTitle: {
      paddingBottom: 10,
      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: '11px',
        lineHeight: '1.1',
        minHeight: '36px',
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
      },
    },
    optionSelectionButton: {
      height: 30,
      width: 30,
      borderRadius: '50%',
      border: '2px solid ' + green,
      backgroundColor: white,
      top: '20px',
      position: 'absolute',
      right: '20px',
      color: 'white',
      cursor: 'pointer',
      '&.selected': {
        backgroundColor: green,
      },
      '& svg': {
        fontSize: '26px',
      },
    },
    imageTileTitle: {
      fontSize: '17px',
      fontFamily: 'Inter',
      fontWeight: 600,
      color: black,
      paddingBottom: 0,
      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: '15px',
      },
    },
    optionImgTile: {
      position: 'relative',
      width: 326,
      height: 'auto',
      paddingBottom: '15px',
      '& img': {
        height: 200,
        width: '100%',
      },
      [theme.breakpoints.between('sm', 'md')]: {
        width: 'calc(25% - 15px)',
        margin: 0,
        paddingBottom: '10px',
        '& img': {
          height: '200px',
          width: '100%',
          objectFit: 'cover',
        },
      },
    },
    optionAbstract: {
      fontFamily: 'Inter',
      fontWeight: 500,
    },
    optionDescription: {
      fontFamily: 'Inter',
      fontWeight: 300,
      fontSize: 15,
      flexGrow: 1,
      '& ul': {
        listStyleType: 'square',
        paddingLeft: 20,
        '& li::marker': {
          fontSize: 20,
          color: green,
        },
      },
      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: 9,
        '& ul': {
          margin: '8px 0',
          '& li': {
            marginBottom: '4px',
          },
        },
      },
    },
    tabs: {
      display: 'flex',
      flexFlow: 'wrap',
      borderBottom: '1px solid ' + lightergrey,
    },
    tabContent: {
      display: 'flex',
      marginTop: 40,
      flexFlow: 'wrap',
      position: 'relative',
      [theme.breakpoints.between('sm', 'md')]: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '20px',
        justifyContent: 'flex-start',
      },
    },
    tab: {
      cursor: 'pointer',
      fontSize: 20,
      paddingBottom: 25,
      marginRight: 30,
      display: 'flex',
      alignItems: 'center',
      minWidth: 100,
      justifyContent: 'center',
      color: lightergrey,
    },
    selectedTab: {
      color: black,
      fontWeight: 500,
      borderBottom: '7px solid' + black,
      paddingBottom: 18,
    },
    markdown: {
      '& li, & p': {
        [theme.breakpoints.between('sm', 'md')]: {
          lineHeight: 1.1,
        },
      },
    },
    clickable: {
      cursor: 'pointer',
    },
    optionTilesScrollContainer: {
      display: 'flex',
      flexDirection: 'row',
      overflowX: 'auto',
      scrollSnapType: 'x mandatory',
      WebkitOverflowScrolling: 'touch',
      width: '100%',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      [theme.breakpoints.up('md')]: {
        overflowX: 'unset',
        scrollSnapType: 'unset',
        width: 'unset',
        scrollbarWidth: 'unset',
      },
    },
    optionTileSnap: {
      flex: '0 0 100%',
      scrollSnapAlign: 'start',
      maxWidth: '100%',
      boxSizing: 'border-box',
      [theme.breakpoints.up('md')]: {
        flex: '1 0 calc(25% - 40px)',
        maxWidth: 'min(452px, 100%)',
        scrollSnapAlign: 'unset',
      },
    },

    indicatorContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    indicatorDot: {
      width: 10,
      height: 10,
      borderRadius: '50%',
      margin: '0 4px',
      background: lightergrey,
      transition: 'background 0.2s',
      '&.active': {
        background: green,
      },
    },
  }),
  {
    name: 'OptionTiles',
  }
);

export interface OptionTilesProps {
  options: Option[];
  selectOption: (option: Option) => void;
  selectedoptions: Option[];
  optionclassification: OptionClassification;
}

const OptionTiles = (props: OptionTilesProps) => {
  const classes = useStyles();
  const { options, selectOption, selectedoptions, optionclassification } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // Mobile scroll snap logic
  const scrollRef = useRef<HTMLDivElement>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Listen to scroll and update indicator
  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;
      const scrollLeft = scrollRef.current.scrollLeft;
      const width = scrollRef.current.offsetWidth;
      const idx = Math.round(scrollLeft / width);
      setCurrentIndex(idx);
    };
    const el = scrollRef.current;
    if (el) el.addEventListener('scroll', handleScroll, { passive: true });
    return () => el && el.removeEventListener('scroll', handleScroll);
  }, []);
  const filteredOptions = options.reduce((r, option) => {
    const filterAttributeValue = get(
      option.attributes.find((attr) => attr.identifier === 'option_group'),
      'values[0]',
      null
    );
    const filterValue = get(filterAttributeValue, 'value');
    r[filterValue] = r[filterValue] || [];
    r[filterValue].push({
      ...option,
      filterValue,
      filterTitle: get(filterAttributeValue, 'translated_value'),
    });
    return r;
  }, {});
  const orderedFilteredOptions = {};
  _(filteredOptions)
    .keys()
    .sort()
    .each((key) => {
      orderedFilteredOptions[key] = filteredOptions[key];
    });
  const [selectedFilter, setSelectedFilter] = useState(get(keys(orderedFilteredOptions), 0));
  const [imageAvailable, setImageAvailable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showPriceInfo, setShowPriceInfo] = useState(false);
  const onPriceClick = () => {
    setShowPriceInfo(true);
  };

  const onCancelPriceInfo = () => {
    setShowPriceInfo(false);
  };

  useEffect(() => {
    if (size(orderedFilteredOptions) > 0) {
      const values = _(orderedFilteredOptions)
        .keys()
        .reduce((res, v) => {
          return res.concat(orderedFilteredOptions[v]);
        }, []);
      if (selectedoptions && selectedoptions.length > 0) {
        const foundOption = values.find(
          (value) => value.identifier === get(selectedoptions[0], 'identifier')
        );
        foundOption && setSelectedFilter(foundOption.filterValue);
      }
    }
  }, [optionclassification]);

  const setImageAvailability = () => {
    setImageAvailable(!imageAvailable);
  };

  const getOptionsList = (filter) => orderedFilteredOptions[filter] || [];

  const getFilterTitle = (filter) => {
    const values = getOptionsList(filter);
    return get(values[0], 'filterTitle', '');
  };

  const handleTabChange = (filter) => {
    setIsLoading(true);
    setSelectedFilter(filter);
    setTimeout(() => setIsLoading(false), 1000);
  };

  const renderImage = (src) => {
    return src && <img src={src} className={classes.optionImage} onError={setImageAvailability} />;
  };

  const renderNotAvailableImage = () => {
    return (
      <div className={clsx('imageNotAvailableElement', classes.optionImage)}>
        <img src={noImage} />
      </div>
    );
  };

  const isImageOnlyTile = (optionclassification) => {
    const attributes = get(optionclassification, 'attributes', []);
    const tileAttribute = attributes.find((attr) => attr.identifier === 'tiles_template');
    const tileAttributeValues = get(tileAttribute, 'values', []);
    return tileAttributeValues.find((val) => val.value === 'image_only_tile');
  };

  const getDeliveryTime = (option) => {
    const attributes = get(option, 'attributes', []);
    const deliveryTimeAttribute = attributes.find((attr) => attr.identifier === 'delivery_time');
    return get(deliveryTimeAttribute, 'values', [])[0]?.value;
  };

  const isSelectedOption = (optionIdentifier) =>
    selectedoptions.find((option) => option.identifier === optionIdentifier);

  const imageOnlyTile = isImageOnlyTile(optionclassification);
  const pricesHidden = hidePrices();

  const renderOptionTile = (option, i) => {
    const thumbnail = get(option, 'thumbnail', '');
    const src = getImageUrl(thumbnail);
    const isSelected = isSelectedOption(option.identifier);
    const deliveryTime = getDeliveryTime(option);
    return imageOnlyTile ? (
      <div
        className={clsx(classes.optionTile, classes.optionImgTile, isSelected && classes.selectedOption)}
        key={i}
      >
        {imageAvailable && src.trim() !== '' ? renderImage(src) : renderNotAvailableImage()}
        <div
          className={clsx(classes.optionSelectionButton, isSelected && 'selected')}
          onClick={() => selectOption({ ...option, amount: 1 })}
        >
          {isSelected && <Check />}
        </div>
        <div className={classes.imgOptionDetails}>
          <Typography
            variant="h4"
            className={clsx(classes.optionTitle, imageOnlyTile && classes.imageTileTitle)}
          >
            {option.title}
          </Typography>{' '}
          {!pricesHidden && (
            <div className={classes.optionPrice}>
              <Typography variant="body2">
                {option.price === 0 ? t('optionTile.noPrice') : t('optionTile.price')}
                {option.price !== 0 && (
                  <Typography
                    className={clsx(classes.optionPrice, classes.clickable)}
                    display={'inline'}
                    onClick={onPriceClick}
                    variant="body2"
                  >
                    {option.priceFormatted + '*'}
                  </Typography>
                )}
              </Typography>
            </div>
          )}
          {deliveryTime && (
            <div className={classes.deliveryTime}>
              <Typography variant="body2">
                {t('deliveryTimeHint.deliveryTime', {
                  weeks: deliveryTime,
                  weekTranslation:
                    deliveryTime !== '1' ? t('deliveryTimeHint.weeks') : t('deliveryTimeHint.week'),
                })}
              </Typography>
            </div>
          )}
        </div>
      </div>
    ) : (
      <div className={clsx(classes.optionTile, isSelected && classes.selectedOption)} key={i}>
        {imageAvailable && src.trim() !== '' ? renderImage(src) : renderNotAvailableImage()}
        <div className={classes.optionDetails}>
          <div>
            <Typography variant="h4" className={classes.optionTitle}>
              {option.title}
            </Typography>
            <Typography variant="body1" className={classes.optionAbstract}>
              {option.abstract}
            </Typography>
            <div className={classes.optionDescription}>
              <MarkdownText text={option.description} className={classes.markdown} />
            </div>
          </div>
          <div>
            <div onClick={onPriceClick} className={classes.priceContainer}>
              {!pricesHidden && (
                <div className={classes.optionPrice}>
                  <Typography variant="body2">
                    {option.price === 0 ? t('optionTile.noPrice') : t('optionTile.price')}
                    {option.price !== 0 && (
                      <Typography
                        className={clsx(classes.optionPrice, classes.clickable)}
                        display={'inline'}
                        onClick={onPriceClick}
                        variant="body2"
                      >
                        {option.priceFormatted + '*'}
                      </Typography>
                    )}
                  </Typography>
                </div>
              )}
              {deliveryTime && (
                <div className={classes.deliveryTime}>
                  <Typography variant="body2">
                    {t('deliveryTimeHint.deliveryTime', {
                      weeks: deliveryTime,
                      weekTranslation:
                        deliveryTime !== '1' ? t('deliveryTimeHint.weeks') : t('deliveryTimeHint.week'),
                    })}
                  </Typography>
                </div>
              )}
            </div>
            <Button
              className={classes.selectBtn}
              variant={isSelected ? 'contained' : 'outlined'}
              onClick={() => selectOption({ ...option, amount: 1 })}
            >
              {isSelected ? t('optionTile.selected') : t('optionTile.choose')}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const renderIndicators = () => {
    if (options.length < 2) {
      return null;
    }
    return (
      <div className={classes.indicatorContainer}>
        {options.map((_, i) => (
          <div key={i} className={clsx(classes.indicatorDot, i === currentIndex && 'active')} />
        ))}
      </div>
    );
  };

  if (isMobile) {
    return (
      <div>
        <div className={classes.optionTilesScrollContainer} ref={scrollRef}>
          {options.map((option, i) => (
            <div className={classes.optionTileSnap} key={i}>
              {renderOptionTile(option, i)}
            </div>
          ))}
        </div>
        {renderIndicators()}
      </div>
    );
  }

  if (size(orderedFilteredOptions) > 1) {
    return (
      <div>
        <PriceInfoDialog onCancel={onCancelPriceInfo} open={showPriceInfo} />
        <div className={classes.tabs}>
          {keys(orderedFilteredOptions).map((filter, i) => {
            return (
              <div
                className={clsx(classes.tab, selectedFilter === filter && classes.selectedTab)}
                key={i}
                onClick={() => handleTabChange(filter)}
              >
                {getFilterTitle(filter)}
              </div>
            );
          })}
        </div>
        <div className={classes.tabContent}>
          <LoadingOverlay show={isLoading} />
          {getOptionsList(selectedFilter).map((option, i) => renderOptionTile(option, i))}
        </div>
      </div>
    );
  }

  return (
    <div className={classes.optionTilesContainer}>
      <PriceInfoDialog onCancel={onCancelPriceInfo} open={showPriceInfo} />
      {options.map((option, i) => renderOptionTile(option, i))}
    </div>
  );
};

export default OptionTiles;
